import { useGetOrganizationApplicationsQuery } from '@/redux/slices/organizationApiSlice';
import { useGetEmployeeApplicationsAccountsQuery } from '@/redux/slices/employeeApiSlice';
import { useGetOrganizationId } from '@/hooks/useGetOrganizationId';

export const useGetEmployeeOrgApplicationAccounts = ({
  employeeId,
  skip = false,
}: {
  employeeId: string;
  skip?: boolean;
}) => {
  const organizationId = useGetOrganizationId();

  const {
    data: organizationApplications,
    isLoading: isLoadingOrganizationApplications,
  } = useGetOrganizationApplicationsQuery(
    {
      organizationId,
      limit: 1000,
    },
    {
      skip,
    }
  );

  const {
    data: employeeApplicationsAccounts,
    isLoading: isLoadingEmployeeApplicationsAccounts,
  } = useGetEmployeeApplicationsAccountsQuery(
    {
      employeeId,
      organizationId,
    },
    {
      skip,
    }
  );

  const employeeAppAccounts = employeeApplicationsAccounts?.results ?? [];

  const employeeOrgApplicationAccounts =
    organizationApplications?.applications?.filter(orgApp =>
      employeeAppAccounts.some(
        account => account.applicationId === orgApp.application.id
      )
    );

  return {
    employeeOrgApplicationAccounts,
    isLoading:
      isLoadingOrganizationApplications ||
      isLoadingEmployeeApplicationsAccounts,
    employeeApplicationsAccounts: employeeAppAccounts,
  };
};
